import { useContext } from 'react'
import { PassContext } from "../../pass-context"
import dataSelector from '../data-selector'
import PopupEditor from '../popup-editor'

const GoogleBackHeader = () => {

  const { classData, objectData, instanceData, scannerInstanceData, passType } = useContext(PassContext)

  const header = getHeader({ passType, classData, objectData, instanceData, scannerInstanceData })

  return (
    <div className="flex flex-col">
      <Header header={header} />
      <div className="inset">
        <span className="">Notifications</span>
      </div>
      <div className="inset">
        <span className="">[your notifications will appear here]</span>
      </div>      
    </div>
  )
}

export default GoogleBackHeader

const Header = ({ header }) => {
  if (header.editable) {
    return (
      <PopupEditor title="Header" path={header.path} sources={header.sources}>
        <div className="header editable">{header.value}</div>
      </PopupEditor>
    )
  } else {
    return (<div className="header">{header.value}</div>)
  }
}

const getHeader = ({ classData, objectData, instanceData, scannerInstanceData, passType }) => {
  try {
    switch (passType) {
      case "generic":
        {
          return {
            editable: true,
            sources: ["object"],
            path: "header.defaultValue.value",
            value: dataSelector({ objectData, instanceData, scannerInstanceData, path: "header.defaultValue.value" }) // Mandatory
          }
        }

      case "eventTicket": {
        return {
          editable: true,
          sources: ["class"],
          path: "eventName.defaultValue.value",
          value: classData.eventName?.defaultValue?.value // Mandatory
        }
      }

      case "flight":
        {
          return {
            editable: false,
            value: "" // Mandatory
          }
        }

      case "transit":
        {
          return {
            editable: false,
            value: getTransitHeader({ instanceData, scannerInstanceData })
          }
        }

      case "offer":
        {
          return {
            editable: true,
            sources: ["class"],
            path: "title",
            value: classData.title // Mandatory
          }
        }
      case "loyalty":
        {
          return {
            editable: true,
            sources: ["class"],
            path: "programName",
            value: classData.programName // Mandatory
          }
        }

      case "giftCard": {
        return {
          editable: true,
          sources: ["object"],
          path: "balance.micros",
          value: getBalanceHeader({ objectData, instanceData, scannerInstanceData }) // Mandatory
        }
      }
    }
  }
  catch (err) {
    console.error(err)
  }
}

const getBalanceHeader = ({ objectData, instanceData, scannerInstanceData }) => {
  const resolvedBalance = dataSelector({ objectData, instanceData, scannerInstanceData, path: "balance" })
  const microsString = Number(resolvedBalance.micros.toString().replace(/[^0-9.-]+/g,""));
  return "Gift Card: " + microsString.toLocaleString('en-US', { style: 'currency', currency: resolvedBalance.currencyCode, minimumFractionDigits: 0 })
}

const getTransitHeader = ({ instanceData, scannerInstanceData }) => {

  const legs = instanceData?.journey?.legs

  if(legs) {
    const resolvedLegs = dataSelector({ objectData: { legs }, instanceData, scannerInstanceData, path: "legs" })

    let firstLeg = resolvedLegs[0]
    let lastLeg = resolvedLegs[resolvedLegs.length - 1]

    return `${firstLeg.origin.code} to ${lastLeg.destination.code}`
  } else {
    return "Journey data missing from instance data"
  }
}